export default __webpack_public_path__ + "static/media/uploadIcon.fe3f2603.svg";